module.exports = __webpack_public_path__ + "img/StaffStyle3.0f1347af.jpg";